import { HugoCookie } from '@popularlab/enums';
import Cookies from 'js-cookie';

import { apiPaths } from '../constants';

// Using named export so we can set up jest spies and mocks in tests.
export const fetchPromise = (url, opts, data) => {
    const options = opts || {};
    const headers = new Headers(options.headers || {});
    headers.set('content-type', 'application/json');

    const csrfTokenCookie = Cookies.get(HugoCookie.CSRF_TOKEN_COOKIE);
    if (csrfTokenCookie) {
        headers.set('X-CSRF-Token', csrfTokenCookie);
    }

    options.headers = headers;

    data && (options.body = JSON.stringify(data));

    return fetch(url, {
        // Default fetch options
        // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
        cache: 'no-store',
        credentials: 'include',
        method: 'GET',
        ...options,
    }).then((response) => {
        // @WARN: Assuming Hugo API will always respond with
        // object and application/json header.
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return response.json().then((json) => {
                if (response.ok) {
                    return json;
                }
                return Promise.reject(json);
            });
        }

        // @WARN: Even if response.ok, fall into catch
        // since it's not expected type.
        throw response;
    });
};

export const apiCall = ({ url = '', data = null, ...rest }) =>
    // Remove query string from GET req.
    fetchPromise(url, { ...rest }, data);

/**
 *
 * @param {*} params
 * @returns
 */
export const createTicket = ({
    firstName,
    lastName,
    email,
    phone,
    message,
    url,
    tags = [],
    recaptchaToken,
}) =>
    apiCall({
        method: 'POST',
        url: apiPaths.CREATE_TICKET,
        data: { firstName, lastName, email, phone, message, url, tags, recaptchaToken },
    });

export const policyHolderLookup = (vin, zipCode, lastName, recaptchaToken) =>
    apiCall({
        method: 'POST',
        url: apiPaths.POLICY_STATUS_LOOKUP,
        data: { vin, zipCode, lastName, recaptchaToken },
    });

export const setAccountFlag = (flag, isEnabled = true) =>
    apiCall({
        url: `${apiPaths.SET_ACCOUNT_FLAG}/${flag}`,
        method: 'PUT',
        data: {
            isEnabled,
        },
    });

/**
 * @returns {Promise<{
 *   data: {
 *     trustScore: number,
 *     reviewCount: number,
 *     excellentPercent: number
 *   } | null
 * }>}
 */
export const getTrustpilotRating = () =>
    apiCall({
        url: apiPaths.GET_TRUSTPILOT_RATING,
    });
